import { render } from "./CutBox.vue?vue&type=template&id=e2bc9188&scoped=true"
import script from "./CutBox.vue?vue&type=script&lang=js"
export * from "./CutBox.vue?vue&type=script&lang=js"

import "./CutBox.vue?vue&type=style&index=0&id=e2bc9188&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2bc9188"]])

export default __exports__